module.exports = "<button [ngClass]=\"className\" *ngIf=\"isShow\">{{ text }}</button>\n"